import { boolean, object, string } from 'yup';
import { CommonValidationTranslations } from '@/core/utils/commonValidationTranslations';
import { stripPhoneNumberFormatting } from '@/core/utils/stripPhoneNumberFormatting';

const phoneNumberRegex = /^[+]?\d{10,15}$/;
export const phoneLoginSchema = object().shape({
  terms: boolean()
    .required(() => CommonValidationTranslations.requiredField())
    .oneOf([true], () => CommonValidationTranslations.requiredField()),
  privacy: boolean()
    .required(() => CommonValidationTranslations.requiredField())
    .oneOf([true], () => CommonValidationTranslations.requiredField()),
  phone: string()
    .transform(stripPhoneNumberFormatting)
    .required(() => CommonValidationTranslations.requiredField())
    .matches(phoneNumberRegex, () => CommonValidationTranslations.invalidPhoneNumber()),
});
